import store from '@/store';
import { logGuard } from '@/router/helpers';
import { RouteNameEnum } from '@/router/RouteName';
import { MiddlewareGroupEnum, middlewareGroups } from '@/router';
export const beforeEachGuard = async (to, from, next) => {
    try {
        const middlewareGroupNames = to
            && to.meta
            && to.meta.middleware
            ? to.meta.middleware
            : [MiddlewareGroupEnum.PRIVATE];
        const middlewareGroup = middlewareGroupNames.map((middlewareGroupName) => middlewareGroups[middlewareGroupName]).flat();
        // console.log('[BEFORE_EACH_GUARD] starting for loop');
        for (let i = 0; i < middlewareGroup.length; i += 1) {
            const middleware = middlewareGroup[i];
            const middlewareResult = await middleware(to, from);
            // console.log('[BEFORE_EACH_GUARD] middlewareResult', middlewareResult);
            if (middlewareResult !== true) {
                // console.log('[BEFORE_EACH_GUARD] starting next(middlewareResult)');
                return next(middlewareResult);
            }
        }
    }
    catch (unknownError) {
        // console.log('[BEFORE_EACH_GUARD] catch unknownError', unknownError);
        if (!unknownError) {
            logGuard('[BEFORE_EACH_GUARD] starting next(new Error(\'beforeEachGuard, error, unknown\')');
            return next(new Error('beforeEachGuard, error, unknown'));
        }
        const error = unknownError;
        logGuard('[BEFORE_EACH_GUARD] error', error);
        const errorStatus = error.response
            && error.response.status
            ? error.response.status
            : undefined;
        const errorMessage = error
            && error.response
            && error.response.data
            && error.response.data.message
            ? error.response.data.message
            : undefined;
        const customErrorMessage = error.message;
        logGuard('[BEFORE_EACH_GUARD] errorStatus', errorStatus, 'errorMessage', errorMessage);
        if (errorStatus === 404) {
            logGuard('[BEFORE_EACH_GUARD] starting setApiOffline', true);
            await store.dispatch('setApiOffline', true);
            logGuard('[BEFORE_EACH_GUARD] after setApiOffline', true);
            if (!to.matched.some((matchedRoute) => matchedRoute.name === RouteNameEnum.PAGE_OFFLINE)) {
                logGuard('[BEFORE_EACH_GUARD] starting next({ name: RouteNameEnum.PAGE_OFFLINE, replace: true })');
                return next({ name: RouteNameEnum.PAGE_OFFLINE, replace: true });
            }
        }
        else {
            logGuard('[BEFORE_EACH_GUARD], error', error);
        }
    }
    logGuard('[BEFORE_EACH_GUARD] starting next()');
    return next();
};
